
<template>
  <div
    class="min-height user-list-main-wrapper cbg-white-container theme--light v-card user-list-wrap-box"
  >
    <CCol sm="12" class="pt-0" v-if="plan">
      <div>
        <CRow>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Plan name :</b>
              {{ plan.settings.plan_name }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Statu :</b>
              {{ plan.settings.status }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Order(s) :  </b>
              {{ plan.settings.order }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Visible on frontend :</b>
              {{ plan.settings.show_on_frontend }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Description :</b>
              {{ plan.settings.description }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Featured :</b>
              {{ plan.settings.featured.join() }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Is free:</b>
              {{ plan.settings.is_free }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Base amount :</b>
              {{ plan.settings.base_amount }}
            </p>
          </CCol>
          <CCol sm="4" class="pb-0">
            <p class="mb-0">
              <b>Plan for :</b>
              {{ plan.settings.plan_for }}
            </p>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <b>Plans</b>
          </CCol>
          <CCol sm="4">
            <v-btn @click="openNewChargeModal()" class="btn btn-primary mt-4 mb-2">Add new plan</v-btn>
            <!-- <button @click="openNewChargeModal()">Add new plan</button> -->
          </CCol>
          <CCol sm="12">
            <table class="table">
              <tbody>
                <tr class="table-success">
                  <th>Sr.No.</th>
                  <th>Name</th>
                  <th>Validity</th>
                  <th>Price</th>
                  <th>Strikethrough price</th>
                  <th>Discount text</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </tbody>
              <tbody>
                <tr v-for="(charge, index) in plan.settings.charges" :key="charge._id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ charge.name }}</td>
                  <td>{{ charge.validity }}</td>
                  <td>{{ charge.price }}</td>
                  <td>{{ charge.strikethrough_price }}</td>
                  <td>{{ charge.discount_text ? charge.discount_text : "Offer for this month" }}</td>
                  <td>{{ charge.show_on_frontend ? "Active" : "In active" }}</td>
                  <td>
                    <button
                      v-if="charge.show_on_frontend"
                      class="btn-danger pl-2 pr-2 pb-1 pt-1 border-radius"
                      @click="
                        changeChargesStatus('inactive', plan._id, charge._id)
                      "
                    >Deactivate Plan</button>
                    <button
                      v-else
                      class="btn-success pl-2 pr-2 pb-1 pt-1 border-radius"
                      @click="
                        changeChargesStatus('active', plan._id, charge._id)
                      "
                    >Activate Plan</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </CCol>
        </CRow>
      </div>
    </CCol>
    <CModal
      :show.sync="addNewChargesModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Add new subscription plan"
      color="dark"
      size="lg"
    >
      <div class="col-sm-12">
        <CRow>
          <CCol sm="4">
            <div class="form-group">
              <label for>Name</label>
              <input type="text" placeholder="Full name" class="form-control" v-model="newCharge.name" />
              <span v-if="validation_error"
      class="text-danger required-fields"
      >This field is required</span>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group">
              <label for>Validity</label>
              <input
                type="text"
                placeholder="Add number of days"
                class="form-control"
                v-model="newCharge.validity"
              />
              <span v-if="validation_error"
      class="text-danger required-fields"
      >This field is required</span>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group">
              <label for>Discounted Price</label>
              <input type="text" placeholder="₹" class="form-control" v-model="newCharge.price" />
              <span v-if="validation_error"
      class="text-danger required-fields"
      >This field is required</span>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group">
              <label for>Discount Text</label>
              <input
                type="text"
                placeholder="Text for discount"
                class="form-control"
                v-model="newCharge.discount_text"
              />
              <span v-if="validation_error"
      class="text-danger required-fields"
      >This field is required</span>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group">
              <label for>Price before discount</label>
              <input
                type="text"
                placeholder="Strike through price"
                class="form-control"
                v-model="newCharge.strikethrough_price"
              />
              <span v-if="validation_error"
      class="text-danger required-fields"
      >This field is required</span>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="form-group">
              <label for class="d-block">Show on frontend</label>
              <div class="d-flex">
                <div>
                  <input
                    type="radio"
                    name="show_on_frontend"
                    :value="true"
                    v-model="newCharge.show_on_frontend"
                    class="show-radio position-relative"
                  />
                  Yes
                </div>

                <div class="pl-3">
                  <input
                    type="radio"
                    name="show_on_frontend"
                    :value="false"
                    v-model="newCharge.show_on_frontend"
                    class="show-radio position-relative"
                  />
                  No
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <CButton color="success" @click="addNewCharges()">Add</CButton>
        <CButton color="danger" @click="addNewChargesModal = false">Close</CButton>
      </template>
    </CModal>
  </div>
</template> 
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import Swal from "sweetalert2";
export default {
  props: {},
  data() {
    return {
      subscriptionId: null,
      plan: null,
      addNewChargesModal: false,
      validation_error : false,
      newCharge: {
        name: null,
        validity: null,
        price: null,
        discount_text: "Offer for this month",
        strikethrough_price: null,
        show_on_frontend: true,
        validation_error : false
      }
    };
  },

  components: {
    ...pickSvg(
      "verticalDotsSVG",
      "nonverifiedUserSVG",
      "verifiedUserSVG",
      "searchSVG",
      "crossSVG"
    )
  },
  methods: {
    openNewChargeModal() {
      this.newCharge = {
        name: null,
        validity: null,
        price: null,
        discount_text: "Offer for this month",
        strikethrough_price: null,
        show_on_frontend: true
      };
      this.addNewChargesModal = true;
    },
    getPlan() {
      const params = { subscription_id: this.subscriptionId };
      let url = `${config.BASE_URL}api/v2/admin/subscription`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.plan = response.body.data;
        }
      });
    },
    changeChargesStatus(status, subscription_id, charge_id) {
      const params = { subscription_id: subscription_id, charge_id: charge_id };
      let url = `${config.BASE_URL}api/v2/admin/subscriptions/charges/${status}`;
      this.$http.post(url, params).then(response => {
        if (response.body.status) {
          this.plan = null;
          this.getPlan();
        }
      });
    },
    addNewCharges() {
      if (this.name !== "" && this.validity !== "" && this.discount_text !=="" && this.strikethrough_price !=="" && this.show_on_frontend !== "")
      {
        if (this.newCharge.strikethrough_price > this.newCharge.price) {
      
      let url = `${config.BASE_URL}api/v2/admin/subscriptions/${this.plan._id}/charges`;
      this.$http.post(url, this.newCharge).then(response => {
        if (response.body.status) {
          this.addNewChargesModal = false;
          this.plan = null;
          this.getPlan();
        }
      });
    }
    else{
      Swal.fire({
          title: "Dicounted price cannot be greated then current price",
          text: "",
          icon: "error",
          confirmButtonText: "Ok",
        
        }).then(result => {
          
        });
      
    }
    }
    else {
      this.validation_error
    }
    }
  },
  created() {
    this.subscriptionId = this.$route.params.id;
    this.getPlan();
  }
};
</script>
